import { useTheme } from '@mui/material';

export const IntroIcon4 = ({ className }: { className: string }) => {
    const theme = useTheme();
    const primaryIconStrokeColor = theme.colors.other.icon.stroke.primary;

    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width="48"
            height="49"
            viewBox="0 0 48 49"
            className={className}
        >
            <path
                fill={primaryIconStrokeColor}
                d="M36.257 26.857c.568 0 1.03.46 1.03 1.029A4.116 4.116 0 0 1 33.171 32H7.114A4.115 4.115 0 0 1 3 27.886c0-.568.46-1.028 1.028-1.029h32.229Zm-31.44 1.714a2.398 2.398 0 0 0 2.297 1.715h26.063a2.398 2.398 0 0 0 2.298-1.715H4.816ZM30.428 8a3.432 3.432 0 0 1 3.428 3.429v13.714h-1.714V11.429c0-.949-.766-1.715-1.714-1.715H9.857c-.948 0-1.714.766-1.714 1.715v10.427l-1.714-.01V11.43A3.432 3.432 0 0 1 9.857 8H30.43ZM21 12.286c.948 0 1.714.766 1.714 1.714v1.714h1.715c.948 0 1.714.766 1.714 1.715v1.714c0 .948-.766 1.714-1.714 1.714h-1.715v1.714c0 .948-.766 1.715-1.714 1.715h-1.714a1.713 1.713 0 0 1-1.715-1.715v-1.714h-1.714a1.713 1.713 0 0 1-1.714-1.714v-1.714c0-.948.766-1.715 1.714-1.715h1.714V14c0-.948.767-1.714 1.715-1.714H21ZM19.286 14v2.571a.861.861 0 0 1-.857.858h-2.572v1.714h2.572a.86.86 0 0 1 .857.857v2.571H21V20a.86.86 0 0 1 .857-.857h2.572v-1.714h-2.572A.86.86 0 0 1 21 16.57V14h-1.714Z"
            />
        </svg>
    );
};
